import React from 'react';
import SEO from "../common/SEO";
import Separator from "../elements/separator/Separator";
import CalltoActionThree from "../elements/calltoaction/CalltoActionThree";
import Layout from "./layout/Layout";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ServiceSix from "../elements/service/ServiceSix";
import ServiceEight from "../elements/service/ServiceEight";


const DigitalMarketing = () => {
    return (
        <>
            <SEO title="Bulk SMS"/>
            <Layout>
                <Separator/>
                {/* Start Service Area  */}
                <div className="service-area rn-section-gapTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="content">
                                    <h3 className="title">Payment Integration</h3>
                                    <h4 className="title">Enhance the performance of your website or web application by incorporating resourceful APIs.</h4>
                                    <p className="mb--10">Our company specializes in assisting enterprises in comprehending the
                                        benefits of integrating third-party APIs for optimizing their processes and enhancing
                                        their overall workflow operations. Some of the most frequently requested APIs by our
                                        clients are listed below. Click on any of the APIs for further information.</p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <img src="../images/ios/integration.jfif" alt="split Images"/>
                            </div>
                        </div>
                    </div>
                </div>
                <Separator/>
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="What Mixon will provide"
                                    description="Our company specializes in assisting enterprises in comprehending the benefits
                                    of integrating third-party APIs for optimizing their processes and enhancing their overall
                                     workflow operations. Some of the most frequently requested APIs by our clients are listed
                                     below. Click on any of the APIs for further information."/>
                            </div>
                        </div>
                        {/* Start Slider Area  */}
                        {/* End Slider Area  */}
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator/>
                <CalltoActionThree/>
            </Layout>
        </>
    )
}
export default DigitalMarketing;
